import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=d264d216&scoped=true&"
import script from "./editor.vue?vue&type=script&lang=js&"
export * from "./editor.vue?vue&type=script&lang=js&"
import style0 from "./editor.vue?vue&type=style&index=0&lang=less&"
import style1 from "./editor.vue?vue&type=style&index=1&id=d264d216&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d264d216",
  null
  
)

export default component.exports